"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopCollectionFilter = void 0;
const utils_1 = require("../../utils/utils");
const sidebar_filters_1 = require("./sidebar-filters");
const SHOP_SELECTOR = 'shop-component';
class ShopCollectionFilter extends sidebar_filters_1.SidebarFilters {
    change() {
        const shop = (0, utils_1.$el)(SHOP_SELECTOR);
        if (shop) {
            this.createQuery();
            shop.updateBySearchParams(this.searchParams);
            const preparedUrl = `${window.location.pathname}?${shop.formatParams(this.searchParams) || ''}`;
            shop.updateFilters(preparedUrl);
        }
    }
}
exports.ShopCollectionFilter = ShopCollectionFilter;
